import { ThisConnector } from '../../../../api/connector'
import { BaseApiResponse } from '../../../../api/shared'

export interface UpdateAttackEventsTagsArgs {
  organizationUuid: string
  ids: string[]
  add: string[]
  remove: string[]
}

export async function updateAttackEventsTags(
  this: ThisConnector,
  { organizationUuid, add, remove, ids }: UpdateAttackEventsTagsArgs
): Promise<BaseApiResponse> {
  const { messages, success } = await this.connector.put<BaseApiResponse>(
    `${organizationUuid}/tags/attack/events/bulk`,
    {
      attack_events_uuid: ids,
      tags: add,
      tags_remove: remove
    }
  )

  return { messages, success }
}
